import {Injectable} from '@angular/core';

@Injectable()
export class StylesService {

  constructor() {
  }

  showInvalidStyles(control: any) {
    return control.touched && !control.valid;
  }

  visibilityClass(control: any) {
    return !this.showInvalidStyles(control) ? 'hidden' : 'visible';
  }

}
